module.exports = " <div class=v-spinner v-show=loading> <div class=\"v-scale v-scale1\" v-bind:style=[spinnerStyle,spinnerDelay1]> </div><div class=\"v-scale v-scale2\" v-bind:style=[spinnerStyle,spinnerDelay2]> </div><div class=\"v-scale v-scale3\" v-bind:style=[spinnerStyle,spinnerDelay3]> </div><div class=\"v-scale v-scale4\" v-bind:style=[spinnerStyle,spinnerDelay4]> </div><div class=\"v-scale v-scale5\" v-bind:style=[spinnerStyle,spinnerDelay5]> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!/home/onlygamescl/onlygames-front/shared/~/vue-spinner/src/ScaleLoader.vue
 ** module id = 315
 ** module chunks = 1
 **/